var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexCompt"},[_c('index',{attrs:{"pageInfo":_vm.orderInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }